/* @flow */

import React from 'react';
import Relay from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { media, css } from 'glamor';

import Logo from './Logo';

import Container from 'depop/components/layout/Container';
import Link from 'depop/components/Link';

import LazyModal from 'depop/components/modal/LazyModal';

import UserMenu from './UserMenu';
import GlobalSearch from './GlobalSearch';

const headerLinkBaseStyle = {
  marginLeft: '1em',
  textDecoration: 'none',
  color: 'inherit',
  fontWeight: 'bold',
  flexShrink: '0',
  flexGrow: '0',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
};

class GlobalHeader extends React.Component {
  props: {
    viewer: Object,
    showSearch: () => void,
    onSearch: () => void,
    toggleDownloadAppModal: () => void,
    toggleFullPageNav: () => void,
    toggleSearch: () => void,
    isFixed: Boolean,
    searchExpanded: Boolean,
  };

  state: {
    isModalVisible: boolean,
  };

  showLogin = () => {
    this.setState({isModalVisible: true});
  };

  hideLogin = () => {
    this.setState({isModalVisible: false});
  };

  showDownloadApp = () => {
    this.setState({isDownloadAppVisible: true});
  }

  hideDownloadApp = () => {
    this.setState({isDownloadAppVisible: false});
  }

  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      isDownloadAppVisible: false,
    };
  }

  render() {
    const {
      viewer,
      onSearch,
      showSearch,
      searchExpanded,
      toggleSearch,
      toggleFullPageNav,
      toggleDownloadAppModal,
      isFixed,
    } = this.props;
    const { isModalVisible } = this.state;

    const opacity = isFixed ? 1 : 0;

    return (
      <div {...css({
        backgroundColor: '#fff',
        fontSize: '16px',
        borderBottom: `1px solid rgba(238,238,238, ${opacity})`,
      })}>
        <Container>
          <div {...css({
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          })}>
            <div {...css({
              marginRight: '1em',
              flexGrow: '0',
              flexShrink: '0',
              height: '27px',
              maxHeight: '27px',
              width: '80px',
            })}>
              <Link to={{pathname: '/'}}><Logo /></Link>
            </div>
            {showSearch && searchExpanded &&
              <GlobalSearch
                onSearch={onSearch}
                searchExpanded={searchExpanded}
                currentUser={viewer.currentUser}
                toggleSearch={toggleSearch} />}
            <div>
              {viewer.currentUser
                ? <UserMenu
                  viewer={viewer}
                  showSearch={showSearch}
                  user={viewer.currentUser}
                  toggleFullPageNav={toggleFullPageNav}
                  toggleSearch={toggleSearch}
                  searchExpanded={searchExpanded} />
                : <nav>
                  {showSearch && !searchExpanded && !viewer.currentUser &&
                    <a
                      {...css({
                        ...headerLinkBaseStyle,
                        display: 'none',
                      })}
                      {...media('(min-width: 701px)', {display: 'inline'})}
                      href="javascript:;"
                      onClick={toggleSearch}>
                      <FormattedMessage
                        id="app.searchLabel"
                        description="Search Label"
                        defaultMessage="Search"
                      />
                    </a>}
                  <Link to="/search"
                    {...css({
                      display: 'inline',
                      color: 'inherit',
                      fontWeight: 'bold',
                      textDecoration: 'none'})}
                    {...media('(min-width: 701px)', {display: 'none'})}>
                    <FormattedMessage
                      id="app.searchLabel"
                      description="Search Label"
                      defaultMessage="Search"
                    /></Link>
                  <span>
                    <a
                      {...css({
                        ...headerLinkBaseStyle,
                        display: 'none',
                      })}
                      {...media('(min-width: 701px)', { display: 'inline' })}
                      onClick={toggleDownloadAppModal}>
                      <FormattedMessage
                        id="app.downloadLabel"
                        description="Download Label"
                        defaultMessage="Download App"
                      />
                    </a>
                  </span>
                  <a
                    {...css(headerLinkBaseStyle)}
                    {...media('(min-width: 701px)', { display: 'none' })}
                    onClick={toggleFullPageNav}
                    href="javascript:;">
                    <FormattedMessage
                      id="app.menuLabel"
                      description="Menu Label"
                      defaultMessage="Menu"
                    />
                  </a>
                  <a
                    {...css(headerLinkBaseStyle)}
                    onClick={this.showLogin}
                    href="javascript:;">
                    <FormattedMessage
                      id="app.loginLabel"
                      description="Login Label"
                      defaultMessage="Login"
                    />
                  </a>
                </nav>}
            </div>

            <LazyModal isOpened={isModalVisible} onClose={this.hideLogin}
              load={() => import('../../../components/login/Login').then(module => module.default)}
              render={Login => <Login closeModal={this.hideLogin} />} />
          </div>
        </Container>
      </div>
    );
  }
}

export default Relay.createContainer(GlobalHeader, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        currentUser {
          ${UserMenu.getFragment('user')}
          ${GlobalSearch.getFragment('currentUser')}
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/components/GlobalHeader.js